<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SdkLogo',

  computed: {
    ...mapGetters([
      'loadedSDKs'
    ])
  }
}
</script>
<template>
  <div class="d-inline">
    <img
      class="src-logo d-inline"
      src="@/assets/images/src-networks/src_logo.png"
    >
    <img
      v-for="(loadedSDK, index) in loadedSDKs"
      :key="index"
      :class="loadedSDK+'-logo'"
      :src="require('@/assets/images/src-networks/' + loadedSDK+'.svg')"
      class="mr-1 d-inline"
    >
  </div>
</template>
